import React, { SetStateAction } from 'react';
import * as Collapsible from '@radix-ui/react-collapsible';
import cn from '@/utils/cn';
import Card from '@/components/ui/Card';
import Icon from '@/components/ui/Icon';
import Text from '@/components/ui/Text';
import { IRubricModalQuestionTranslation } from './AddRubricModal.types';

interface IQuestionPromptProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<SetStateAction<boolean>>;
  translation: IRubricModalQuestionTranslation;
}

const QuestionPrompt = ({ isOpen, setIsOpen, translation }: IQuestionPromptProps) => (
  <Collapsible.Root open={isOpen} onOpenChange={setIsOpen}>
    <Card
      className={cn(
        'allow-list-style tw-min-h-min tw-min-w-min',
        'tw-shadow-none hover:tw-shadow-none tw-border tw-border-light-grey tw-rounded tw-border-solid',
      )}
    >
      <div className="tw-flex tw-justify-between tw-bg-light-grey tw-w-full tw-px-3.5 tw-py-2.5 tw-box-border">
        <Text weight="semibold">Question Prompt</Text>
        <Collapsible.Trigger
          className={cn(
            'btn tw-cursor-pointer tw-bg-transparent tw-p-0 tw-shadow-none tw-box-border tw-aspect-square',
            'tw-w-7 tw-h-7 tw-inline-flex tw-items-center tw-justify-center',
          )}
        >
          <Icon
            icon={isOpen ? 'ChevronUp' : 'ChevronDown'}
            size={16}
          />
        </Collapsible.Trigger>
      </div>
      <Collapsible.CollapsibleContent className="CollapsibleContent">
        <Card.Body className="tw-p-3.5">
          <Text className="tw-whitespace-pre-wrap">
            <span dangerouslySetInnerHTML={{ __html: translation.body }} />
          </Text>
        </Card.Body>
      </Collapsible.CollapsibleContent>
    </Card>
  </Collapsible.Root>
);

export default QuestionPrompt;
